import type { InsuranceFormValues } from '../../../../types';

export const INSURANCE_INITIAL_VALUES: InsuranceFormValues = {
  insurance_name: '',
  relationship_to_policyholder: '',
  member_first_name: '',
  member_last_name: '',
  insurance_start_date: null,
  insurance_end_date: null,
  member_id: '',
  group_number: '',
  member_street_address_line_one: '',
  member_street_address_line_two: '',
  member_street_address_city: '',
  member_street_address_state: '',
  member_street_address_zip: '',
  policyholder_first_name: '',
  policyholder_last_name: '',
  policyholder_date_of_birth: null,
  policyholder_phone: '',
  policyholder_gender: '',
  policyholder_address_same_as_member: false,
  policyholder_street_address_line_one: '',
  policyholder_street_address_line_two: '',
  policyholder_street_address_city: '',
  policyholder_street_address_state: '',
  policyholder_street_address_zip: '',
};

export const INSURANCE_FORM_FIELD_NAMES = [
  'insurance_name',
  'relationship_to_policyholder',
  'member_first_name',
  'member_last_name',
  'insurance_start_date',
  'insurance_end_date',
  'member_id',
  'group_number',
  'member_street_address_line_one',
  'member_street_address_line_two',
  'member_street_address_city',
  'member_street_address_state',
  'member_street_address_zip',
  'policyholder_first_name',
  'policyholder_last_name',
  'policyholder_date_of_birth',
  'policyholder_phone',
  'policyholder_gender',
  'policyholder_address_same_as_member',
  'policyholder_street_address_line_one',
  'policyholder_street_address_line_two',
  'policyholder_street_address_city',
  'policyholder_street_address_state',
  'policyholder_street_address_zip',
] as const;

export const INSURANCE_DATE_FIELD_NAMES = [
  'insurance_start_date',
  'insurance_end_date',
  'policyholder_date_of_birth',
] as const;

export const POLICYHOLDER_ADDRESS_SAME_AS_MEMBER_FIELD_NAME = 'policyholder_address_same_as_member';

export const MEMBER_TO_POLICYHOLDER_ADDRESS_FIELDS = [
  ['member_street_address_line_one', 'policyholder_street_address_line_one'],
  ['member_street_address_line_two', 'policyholder_street_address_line_two'],
  ['member_street_address_city', 'policyholder_street_address_city'],
  ['member_street_address_state', 'policyholder_street_address_state'],
  ['member_street_address_zip', 'policyholder_street_address_zip'],
] as const;

export const MEMBER_REQUIRED_ADDRESS_FIELD_NAMES = [
  'member_street_address_line_one',
  'member_street_address_city',
  'member_street_address_state',
  'member_street_address_zip',
] as const;

export const EXTRACTION_JOB_STATUS = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
} as const;

export const INSURANCE_CARD_EXTRACTION_POLL_INTERVAL_SECONDS = 5;

// Fields rendered in the "Insurance Information" section of the form. Used both to scope the
// extraction lock/loader and to require overwrite confirmation before auto-extraction when the
// section already holds data.
export const INSURANCE_INFORMATION_SECTION_FIELD_NAMES = [
  'insurance_name',
  'relationship_to_policyholder',
  'insurance_start_date',
  'insurance_end_date',
  'member_id',
  'group_number',
  'member_first_name',
  'member_last_name',
  'member_street_address_line_one',
  'member_street_address_line_two',
  'member_street_address_city',
  'member_street_address_state',
  'member_street_address_zip',
] as const;

export const INSURANCE_CARD_EXTRACTION_STORAGE_KEY_PREFIX = 'onboarding:insuranceExtraction:';
